import z from 'zod';
import { PROJECT_CODE_SCHEMA } from '../project/project.ts';

/**
 * validation schema for request payload
 */
export const PostCustomerInfoRequestSchema = z.object({
    organizationId: z.number(),
    userId: z.number(),
    manualCostCenter: z.string().trim().nonempty().optional().nullable(),
    constructionProjectId: z.string().uuid(),
    projectCode: PROJECT_CODE_SCHEMA,
});
